import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const SELECTOR =
    '[data-map-suggestion-path-preview]';

function parsePath(value) {
    try {
        const parsed = JSON.parse(
            value || '[]'
        );

        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed
            .map((point) => {
                const latitude =
                    Number.parseFloat(
                        point?.latitude
                    );

                const longitude =
                    Number.parseFloat(
                        point?.longitude
                    );

                if (
                    !Number.isFinite(latitude)
                    || !Number.isFinite(longitude)
                ) {
                    return null;
                }

                return [
                    latitude,
                    longitude,
                ];
            })
            .filter(Boolean);
    } catch {
        return [];
    }
}

function initializePreview(preview) {
    if (
        preview.dataset
            .mapSuggestionPathPreviewReady
        === 'true'
    ) {
        return;
    }

    const canvas = preview.querySelector(
        '[data-map-suggestion-path-preview-canvas]'
    );

    const suggestedPath =
        parsePath(
            preview.dataset
                .suggestedPath
        );

    const existingPath =
        parsePath(
            preview.dataset
                .existingPath
        );

    if (
        !canvas
        || suggestedPath.length < 2
    ) {
        return;
    }

    preview.dataset
        .mapSuggestionPathPreviewReady =
            'true';

    const map = L.map(
        canvas,
        {
            zoomControl: true,
            scrollWheelZoom: false,
        }
    ).setView(
        suggestedPath[0],
        17
    );

    L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
            maxZoom: 20,
            attribution:
                '&copy; OpenStreetMap contributors',
        }
    ).addTo(map);

    const allPoints = [];

    if (existingPath.length >= 2) {
        L.polyline(
            existingPath,
            {
                color: '#71717a',
                weight: 3,
                dashArray: '7 5',
                opacity: 0.75,
            }
        )
            .addTo(map)
            .bindTooltip(
                'Current official path'
            );

        allPoints.push(
            ...existingPath
        );
    }

    L.polyline(
        suggestedPath,
        {
            color: '#2563eb',
            weight: 5,
            opacity: 0.9,
        }
    )
        .addTo(map)
        .bindTooltip(
            'Suggested path / trail'
        );

    suggestedPath.forEach(
        (point, index) => {
            L.circleMarker(
                point,
                {
                    radius: 5,
                    color: '#ffffff',
                    weight: 2,
                    fillColor: '#2563eb',
                    fillOpacity: 1,
                }
            )
                .addTo(map)
                .bindTooltip(
                    `Point ${index + 1}`,
                    {
                        direction: 'top',
                    }
                );
        }
    );

    allPoints.push(
        ...suggestedPath
    );

    const bounds =
        L.latLngBounds(
            allPoints
        );

    if (bounds.isValid()) {
        map.fitBounds(
            bounds,
            {
                padding: [30, 30],
                maxZoom: 18,
                animate: false,
            }
        );
    }

    window.setTimeout(
        () => map.invalidateSize(),
        100
    );
}

function initializePreviews() {
    document
        .querySelectorAll(SELECTOR)
        .forEach(initializePreview);
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializePreviews,
        {
            once: true,
        }
    );
} else {
    initializePreviews();
}

document.addEventListener(
    'livewire:navigated',
    initializePreviews
);
